import React from "react"
import Footer from "../components/footer"
// normalize CSS across browsers
import "../styles/normalize.css"
// custom CSS styles
import "../styles/style.css"
// import { AnimatePresence } from 'framer-motion'
// <AnimatePresence initial={false} exitBeforeEnter>
// </AnimatePresence>

const Layout = ({ isHomePage, children, hideFooter = false }) => {
  return (
    <>
      {children}
      {
        (!hideFooter) ?
        <Footer/>
        : ''
      }
      
    </>
  )
}

export default Layout
